import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const PinMap_sm = (props) => {
    const width = props.width ? props.width + 'px' : '20px';
    const height = props.height ? props.height + 'px' : '20px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 20 20"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.5 1.72491L12.5 3.02926L15.2233 2.31883C16.7545 1.9194 18.25 3.07484 18.25 4.65724V14.908C18.25 16.0077 17.5075 16.9688 16.4434 17.2464L12.5 18.2751L7.5 16.9708L4.77668 17.6812C3.24552 18.0806 1.75 16.9252 1.75 15.3428V5.09202C1.75 3.99228 2.49251 3.03122 3.55665 2.75362L7.5 1.72491ZM8.25 15.6162L11.75 16.5293V4.38381L8.25 3.47077V15.6162ZM6.75 3.47077V15.6162L4.39805 16.2298C3.81727 16.3813 3.25 15.943 3.25 15.3428V5.09202C3.25 4.67488 3.53164 4.31034 3.93528 4.20504L6.75 3.47077ZM13.25 4.38381V16.5293L16.0647 15.795C16.4684 15.6897 16.75 15.3251 16.75 14.908V4.65724C16.75 4.05702 16.1827 3.61875 15.6019 3.77026L13.25 4.38381Z"
            />
        </SvgStyled>
    );
};

export default PinMap_sm;
